// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"627":"9cb5d66b","942":"e755e8aa"}[chunkId] + ".chunk.css";
};